export default function() {
  return {
    aggregations: null,
    operations: null,
    comparisons: null,
  };
}
